export default {
  data() {
    return {
      industriesListLink: [
        // {
        //   title: 'Промышленность',
        //   href: '/task/industry/',
        //   icon: {
        //     name: 'icon-mts--delivery',
        //     alt: 'Промышленность',
        //   },
        // },
        {
          title: 'Здравоохранение',
          href: '/task/healthcare/',
          icon: {
            name: 'icon-mts--heartAdd',
            alt: 'Здравоохранение',
          },
        },
        {
          title: 'Образование',
          href: '/task/obuchenie_studentov/',
          icon: {
            name: 'icon-mts--education',
            alt: 'Образование',
          },
        },
        {
          title: 'Госсектор',
          href: '/task/govermental/',
          icon: {
            name: 'icon-mts--federal',
            alt: 'Госсектор',
          },
        },
        {
          title: 'Финансы',
          href: '/task/finance/',
          icon: {
            name: 'icon-mts--diagram',
            alt: 'Финансы',
          },
        },
        {
          title: 'Торговые\u00A0компании',
          href: '/task/retail/',
          icon: {
            name: 'icon-mts--online-shopping',
            alt: 'Торговые компании',
          },
        },
        {
          title: 'IT',
          href: '/task/it/',
          icon: {
            name: 'icon-mts--gpu',
            alt: 'IT',
          },
        },
      ],
      productsListLink: [
        {
          title: 'Встречи',
          icon: {
            name: 'icon-mts--videoReview',
            alt: 'Встречи',
          },
          href: '/products/meetings/',
        },
        {
          title: 'Вебинары',
          icon: {
            name: 'icon-mts--calendar',
            alt: 'Вебинары',
          },
          href: '/products/webinar/',
        },
        {
          title: 'Курсы',
          icon: {
            name: 'icon-mts--audiobook',
            alt: 'Курсы',
          },
          href: '/products/westudy/',
        },
        {
          title: 'Чаты',
          icon: {
            name: 'icon-mts--chat',
            alt: 'Чаты',
          },
          href: '/products/messenger/',
        },
        {
          title: 'Доcки',
          icon: {
            name: 'icon-mts--shape',
            alt: 'Доcки',
          },
          href: '/products/boards/',
        },
        {
          title: 'COMDI',
          icon: {
            name: 'icon-mts--hotspot',
            alt: 'COMDI',
          },
          href: '/products/comdi/',
        },
        {
          title: 'Формы',
          icon: {
            name: 'icon-mts--quotes',
            alt: 'Формы',
          },

          href: '/products/forms/',
          text: '',
        },
        {
          title: 'Оборудование',
          icon: {
            name: 'icon-mts--dvr-camera',
            alt: 'Оборудование',
          },
          href: '/products/software-and-equipment/',
          text: '',
        },
      ],
      toggleNameDropdown: 0,
      translateForContent: 0,
    }
  },
  methods: {
    openDropdown(number) {
      this.toggleNameDropdown = number
      this.translateForContent = event.target.offsetLeft - 73
    },
  },
}
